'use strict';

module.exports = /*@ngInject*/
function(
    AnthroConfig
) {
    return {
        getImageUrl: function(productId, colorCode, viewCode) {
            var imageUrl = AnthroConfig.scene7.imagePath + productId + '_' + colorCode + '_' + viewCode;

            return imageUrl;
        },
        getVideoUrl: function(productId, colorCode) {
            var videoUrl = AnthroConfig.scene7.videoPath + productId + '_' + colorCode + '_vid';

            return videoUrl;
        },

        getLookbookImageUrl: function(categoryId, lookId) {
            var lookbookImageUrl = AnthroConfig.scene7.imagePath + categoryId + '-' + lookId;

            return lookbookImageUrl;
        }
    };
};
